import { render, staticRenderFns } from "./CppView.vue?vue&type=template&id=20aa4674&scoped=true&"
import script from "./CppView.vue?vue&type=script&lang=js&"
export * from "./CppView.vue?vue&type=script&lang=js&"
import style0 from "./CppView.vue?vue&type=style&index=0&id=20aa4674&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20aa4674",
  null
  
)

export default component.exports